import React from 'react';
import Modal from 'components/commons/modal/Modal2';

export const InformationFromMoneytreeModal = ({
  hideModal,
  isShowModal,
}: {
  isShowModal: boolean;
  hideModal: () => void;
}) => {
  return (
    <>
      <Modal isShow={isShowModal} close={hideModal} closeOnClickOutsideWindow>
        <div className="max-h-modal overflow-y-auto">
          <div className="flex mt-2 mx-3 p-2">
            <div className="flex-grow text-lg font-bold text-gray-800">
              Moneytreeから取得できる情報
            </div>
            <button>
              <i
                className="icon-close text-2xl text-gray-500 text-center cursor-pointer"
                onClick={hideModal}></i>
            </button>
          </div>
          <img src="/static/images/mt_taio.png" alt="Moneytree 対応表" />
          <div
            onClick={hideModal}
            className="flex justify-center text-gray-500 m-1 p-2 cursor-pointer">
            閉じる
          </div>
        </div>
      </Modal>
    </>
  );
};
